export default "__VITE_ASSET__D63fL8cl__"